import React from 'react';
import { motion } from 'framer-motion';

const Mascot = ({ 
  variant = 'default', 
  className = '',
  animate = true 
}) => {
  // Placeholder para la mascota - el usuario subirá las imágenes
  const mascotImages = {
    default: '/assets/mascot-default.png',
    login: '/assets/mascot-login.png',
    register: '/assets/mascot-register.png',
    success: '/assets/mascot-success.png',
    error: '/assets/mascot-error.png',
    loading: '/assets/mascot-loading.png',
  };

  const animations = {
    default: {
      y: [0, -10, 0],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
    bounce: {
      y: [0, -20, 0],
      transition: {
        duration: 1,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  return (
    <motion.div
      className={`flex items-center justify-center ${className}`}
      animate={animate ? animations.default : {}}
    >
      <div className="relative w-full h-full flex items-center justify-center">
        {/* Placeholder mientras no haya imagen */}
        <div className="w-64 h-64 bg-gradient-to-br from-primary-light to-primary rounded-full flex items-center justify-center shadow-2xl">
          <span className="text-white text-6xl font-bold">🎯</span>
        </div>
        
        {/* Imagen de mascota cuando se agregue */}
        <img
          src={mascotImages[variant]}
          alt="PostPsic Mascot"
          className="hidden w-full h-full object-contain"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.previousSibling.style.display = 'flex';
          }}
          onLoad={(e) => {
            e.target.style.display = 'block';
            e.target.previousSibling.style.display = 'none';
          }}
        />
      </div>
    </motion.div>
  );
};

export default Mascot;
